import { IFFM, IQueue, IRack, SelectOption, IULD, IFlightSchedule } from "./interfaces"

export const queueRecord: IQueue = {
    id: 0,
    t_created: '',
    s_created_by: '',
    t_modified: '',
    s_modified_by: '',
    s_unit: '',
    s_transaction_id: '',
    s_type: '',
    s_priority: '',
    s_state: 'EXPORT',
    s_status: 'WAITING',
    s_mawb: '',
    s_mawb_id: '',
    s_airline: '',
    s_airline_code: '',
    s_trucking_company: '',
    s_trucking_driver: '',
    s_trucking_cell: '',
    b_trucking_sms: false,
    s_trucking_email: '',
    s_trucking_language: '',
    t_kiosk_start: '',
    t_kiosk_submitted: '',
    s_counter_ownership_agent: '',
    t_counter_ownership: '',
    t_counter_start: '',
    t_counter_end: '',
    s_abandoned_agent: '',
    t_abandoned: '',
    s_restored_agent: '',
    t_restored: '',
    s_restored_reason: '',
    s_notes: '',
    ic_counter_time_waited: '',
    ic_counter_time_processed: '',
    b_counter_reject: '',
    s_counter_reject_agent: '',
    t_counter_reject_time: '',
    s_counter_reject_reason: '',
    b_isc_paid: '',
    t_dock_door: '',
    s_dock_door_assigned: '',
    s_dock_ownership: '',
    t_dock_ownership: '',
    s_hawb: '',
    s_dock_door_guid: '',
    s_warehouse_productivity_guid: '',
    b_dock_reject: '',
    s_dock_reject_reason: '',
    s_dock_door: '',
    sm_driver_photo: '',
    t_dock_complete: '',
    s_dock_agent_completed: '',
    ic_total_engagement_time: '',
    i_feedbackscore: '',
    s_driver_photo_link: '',
    ic_warehouse_wait: '',
    sc_warehouse_ownership_username: '',
}

export const rackItem: Partial<IRack> = {
    id: 0,
    s_status: '',
    s_mawb: '',
    s_hawb: '',
    s_location: '',
    i_pieces: 0,
    s_destination: '',
    s_flight_uld: '',
    s_flight_id: '',
    t_created: '',
    t_modified: '',
    s_created_by: '', 
    s_modified_by: '',
    b_delivered: false,
    s_platform: ''
}

export const defaultUld: IULD = {
    id: 0,
    i_unique: 0,
    s_flight_id: '',
    s_status: '',
    s_airline_code: '',
    s_flight_number: '',
    s_flight_serial: '',
    d_arrival_date: new Date(),
    s_origin: '',
    s_destination: '',
    f_weight: 0,
    s_weight_type: '',
    i_pieces_total: 0,
    s_volume: '',
    s_uld: '',
    s_uld_type: '',
    s_uld_number: '',
    s_uld_code: '',
    s_message_type: '',
    t_created: new Date(),
    s_created_by: '',
    s_modified_by: '',
    t_modified: new Date(),
    s_notes: '',
    s_pol: '',
    s_pou: '',
    s_user_accepted_uld: '',
    t_user_accepted_uld: new Date(),
    s_user_opened_uld: '',
    t_user_opened_uld: new Date(),
    s_user_closed_uld: '',
    t_user_closed_uld: new Date(),
    s_shc: '',
    b_accepted: false,
    b_opened: false,
    b_closed: false,
    s_unit: '',
    s_platform: '',
    b_offloaded: false,
    b_message_complete: false,
    s_parser_guid: '',
    s_guid: '',
}

export const defaultSelectOption: SelectOption = {
    label: '',
    value: ''
}

export const defaultFfm: IFFM = {
    id: 0,
    s_parser_guid: '',
    s_message_type: '',
    i_unique: 0,
    i_message_sequence: 0,
    b_message_complete: false,
    b_has_continuation: false,
    s_flight_number: '',
    d_arrival_date: new Date(),
    d_departure_date: new Date(),
    t_scheduled_time: '',
    s_pol: '',
    s_pou: '',
    s_aircraft_registration: '',
    t_actual_arrival: new Date(),
    s_flight_id: '',
    s_uld: '',
    s_uld_type: '',
    s_uld_number: '',
    s_uld_code: '',
    s_uld_remarks: '',
    s_uld_loading_indicator: '',
    s_mawb: '',
    s_origin: '',
    s_destination: '',
    s_pieces_type: '',
    i_actual_piece_count: 0,
    f_weight: 0,
    s_weight_type: '',
    i_pieces_total: 0,
    s_volume: '',
    s_volume_unit: '',
    i_total_consignment_pieces: 0,
    s_commodity: '',
    s_special_handling_code: '',
    s_movement_priority: '',
    s_customs_origin_code: '',
    s_onward_routing_booking_carrier_code: '',
    s_onward_routing_booking_destination: '',
    s_onward_routing_booking_flight_number: '',
    d_onward_routing_booking_Date_departure: new Date(),
    s_other_service_information: '',
    t_created: new Date(),
    s_created_by: '',
    t_modified: new Date(),
    s_modified_by: '',
    s_status: '',
    d_storage_first_free: new Date(),
    d_storage_second_free: new Date(),
    d_storage_third_free: new Date(),
    d_storage_start: new Date(),
    s_arrived_weekday: '',
    i_arrived_Date: 0,
    i_arrived_year: 0,
    i_arrived_month: 0,
    s_arrived_month: '',
    i_arrived_week: 0,
    s_guid: '',
    s_airline_code: '',
    s_notes: '',
    b_customs_hold: false,
    b_usda_hold: false,
    b_hold: false,
    b_breakdown_hawb: false,
    s_flight_serial: '',
}

export const defaultFlightSchedule: IFlightSchedule = {
    id: 0,
    s_unit: "",
    s_status: "",
    s_flight_type: "",
    s_airline_name: "",
    s_airline_code: "",
    s_flight_number: "",
    s_aircraft: "",
    s_aircraft_type: "",
    s_origin_airport: "",
    t_estimated_departure: new Date(),
    t_actual_departure: new Date(),
    t_cut_off_time: new Date(),
    t_uws_time: new Date(),
    s_destination_airport: "",
    t_estimated_arrival: new Date(),
    t_actual_arrival: new Date(),
    t_sla_breakdown: new Date(),
    s_notes: "",
    s_created_by: "",
    t_created: new Date(),
    s_modified_by: "",
    t_modified: new Date(),
    s_flight_id: "",
    f_aircraft_capacity: 0,
}